/* eslint-disable */
import React, {Fragment, Component} from 'react'
import PropTypes from 'prop-types'
import Logo from '../../components/Logo'

export default class Wrapper extends Component {
	render() {
		const {children, showFaq} = this.props

		return (
			<Fragment>
				<header className="login-screen">
					<div className="content-wrap">
						<Logo />
					</div>
					<div className="content-wrap">
						<div className="action-container">
							{children}<br />
						</div>
						<div className="info-box">
							<h2>Note</h2>
							<p>Unsubscribing from AdMonitor will permanently remove all historical data associated with this ad account.</p>
						</div>
					</div>
				</header>
			</Fragment>
		)
	}
}

Wrapper.propTypes = {
	children: PropTypes.element.isRequired
}


// WEBPACK FOOTER //
// ./src/containers/Unsubscribe/wrapper.js